export let opt_chart = {
    // title: {
    //     text: '工单处理状态分布',
    //     padding: 10,
    //     left: 'center'
    // },
    newline: function (option, number, axis) {
        /* 此处注意你的json是数组还是对象 */
        option[axis][0]['axisLabel']={
        // option[axis]['axisLabel'] = {
            interval: 0,
            formatter: function (params) {
                let dotFlag = false;
                let paramsList = params.split('#');
                var newParamsName = "";
                // var paramsNameNumber = params.length;
                var paramsNameNumber = paramsList[0].length;
                console.log("newline====>",params.split('#'));
                var provideNumber = number;
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                        if(p > 1){
                            if(dotFlag){
                                
                            }else{
                                console.log("newParamsName==========>",newParamsName);
                                dotFlag = true;
                                newParamsName = newParamsName +'...';
                            }
                        }else{
                            var tempStr = "";
                            var start = p * provideNumber;
                            var end = start + provideNumber;
                            if (p == rowNumber - 1) {
                                
                                tempStr = paramsList[0].substring(start, paramsNameNumber);
                                // tempStr = params.substring(start, paramsNameNumber);
                            } else {
                                // tempStr = params.substring(start, end) + "\n";
                                tempStr = paramsList[0].substring(start, end) + "\n";
                            }
                            newParamsName += tempStr;
                        }
                    }
                } else {
                    // newParamsName = params;
                    newParamsName = paramsList[0];
                }
                return newParamsName+"\n"+paramsList[1]
            }
        }
        return option;
    },

    line_opt: {
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}'
        },
        legend: {
            data: ['近7天工单量']
        },
        grid: {
            top:'15%'
        },
        xAxis: {
            type: 'category',
            data: ['啊大王Mon大大Mon啊大王大大Mon啊大王大大Mon啊大王大大', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
            type: 'value'
        },
        series: [{
            name: '近7天工单量',
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line'
        }]
    },
    line_basic_opt: {
        tooltip: {
            trigger: 'item',
            formatter: '<div style="width:17rem;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{b}: </div>{c}',
            
            // formatter (params) {
            //     return tooltipCustom({
            //       body: [
            //         {
            //           key: params.data.chartsShowTip,
            //           value: params.value,
            //         }
            //       ],
            //     })
            //   },
            position: function (point, params, dom, rect, size) {
                return {top: '-20%'};
              }
        },
        grid: {
            top:'10%',
            left:'10%',
            right:'2%',
        },
        xAxis: [{
            show : false,
            type: 'category',
            data: ['啊大王啊大王啊大王啊大王Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        }],
        yAxis: {
            type: 'value'
        },
        series: [{
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar'
        }]
    },
    line_basic_opt_: {
        tooltip: {
            trigger: 'item',
            formatter: '<div style="width:16rem;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{b}: </div>{c}',
            // formatter: function(params, ticket, callback) {
            //     // console.log(params, "");
            //     let res = `<div><div>${params[0].axisValue }：${params[0].value} </div><div>日期：${params[0].data.day}</div></div>`;
            //     return res;
            //   },
            position: function (point, params, dom, rect, size) {
                return {top: '-20%'};
              }
        },
        grid: {
            top:'10%',
            left:'10%',
            right:'2%',
        },
        xAxis: [{
            show : false,
            type: 'category',
            data: ['啊大王啊大王啊大王啊大王Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        }],
        yAxis: {
            type: 'value'
        },
        series: [{
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar'
        }]
    },
    //设备统计
    line_horizon_opt: {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            top:'10%',
            bottom:'10%',
            containLabel: true
        },
        xAxis: {
            show: false
        },
        yAxis: {
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            },
            axisLabel:{
                fontSize:16
            },
            type: 'category',
            data: []
        },
        series: [
            {
                type: 'bar',
                data: [],
                label: {
                    position: 'right',
                    show: true,
                    fontSize: 16,
                },
            }
        ]
    },
    line_bar_opt: {
        tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        legend: {
            data: ['临床评价值', '患者满意度', '成本结余', '实际创收'],
            top:10,
            right:'10%'
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top:'20%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: []
            }
        ],
        yAxis: [
            {
                type: 'value',
                // name: '百分比',
                // min: 0,
                max: 100,
                splitNumber: 10,
                // axisLine:{
                //     lineStyle:{
                //         color:'#333'
                //     }
                // }
            },
            {
                type: 'value',
                // name: '元',
                // min: -1000000,
                // max: function (value) {
                //     let tempStr = value.max + "";
                //     let len = tempStr.length;
                //     if (tempStr[0] < 5) {
                //         tempStr = '5'.padEnd(len, '0')
                //     } else {
                //         tempStr = '1'.padEnd(len + 1, '0')
                //     }
                //     return Number(tempStr);
                // },
                splitNumber: 10,
            },
        ],
        series: [
            {
                name: '临床评价值',
                type: 'line',
                yAxisIndex: 0,
                data: [],
            },
            {
                name: '患者满意度',
                type: 'line',
                yAxisIndex: 0,
                data: [],

            },
            {
                name: '成本结余',
                type: 'bar',
                yAxisIndex: 1,
                stack: '金额',

                emphasis: {
                    focus: 'series'
                },
                data: []

            },
            {
                name: '实际创收',
                type: 'bar',
                yAxisIndex: 1,
                stack: '金额',
                emphasis: {
                    focus: 'series'
                },
                data: []
            }
        ]
    },
    bar_opt: {
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}'
        },
        legend: {
            orient: 'vertical',
            left: 0,
            top: 5
        },
        series: [
            {
                left: 100,
                type: 'pie',
                radius: ['30%', '45%'],
                label: {
                    show: true,
                    formatter: '{b} {c}'
                },
                emphasis: {
                    label: {
                        show: true
                    }
                },
                data: []//
            }
        ]
    },
}